<template>
  <div v-bind:id="_createIdentifier(prop)">
    <v-row
      @click="collapseModel = !collapseModel"
      v-if="prop != null"
      align="center"
      justify="start"
      class="ma-0 mt-2 mb-1 pa-0"
      :class="{
        'section-title-collapse': collapse,
        'section-title-modified': modified,
        'section-title': !modified,
      }"
    >
      <v-col :cols="collapse ? 11 : 12" class="ma-0 pa-0 pl-2">
        <span class="pa-0 ma-0">
          {{ prop }}
          <sup
            class="vetalfa-pointer text--disabled"
            style="font-weight: normal; font-size: 10.5px"
            v-if="references && references.length"
            @click="setClickedReferences(references)"
            >{{ "[ref]" }}
          </sup>
        </span>
      </v-col>
      <v-col :cols="1" class="ma-0 pa-0">
        <v-icon color="#193153" size="14" v-if="collapse">
          {{ collapseModel ? icon.mdiChevronDown : icon.mdiChevronUp }}
        </v-icon>
      </v-col>
    </v-row>
    <slot v-if="!collapse || !collapseModel"></slot>
  </div>
</template>

<style>
.section-title {
  background-color: rgb(0, 114, 138, 0.14);
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  color: #193153;
}
.section-title-modified {
  background-color: transparent;
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  color: #193153;
}
.section-title-collapse {
  cursor: pointer;
}
</style>

<script>
import { mdiChevronDown, mdiChevronUp } from "@mdi/js";
import { mapMutations } from "vuex";
export default {
  name: "SectionTitle",
  methods: {
    ...mapMutations("topics", ["setClickedReferences"]),
  },
  props: {
    prop: {
      type: String,
    },
    collapse: {
      type: Boolean,
      default: false,
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    references: {
      type: Array,
      default: null,
      required: false,
    },
    modified: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isCollapsed(val) {
      this.collapseModel = val;
    },
  },
  data() {
    return {
      icon: {
        mdiChevronDown,
        mdiChevronUp,
      },
      collapseModel: false,
    };
  },
  created() {
    this.collapseModel = this.isCollapsed;
  },
};
</script>